// extracted by mini-css-extract-plugin
export var icon = "_46-3";
export var subtitle = "_46-2";
export var title = "_46-1";
export var value = "_46-0";